import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { Plus } from 'lucide-react';


/**
 * Main application layout scaffold.
 * Manages sidebar active state and provides WebSocket context to nested routes.
 * Styled entirely with Tailwind CSS for responsiveness.
 */
const Scaffold = () => {
    const lcUserString = localStorage.getItem("user")
    const lcUser = lcUserString ? JSON.parse(lcUserString) : null;
    const userId = lcUser?.users_id || null;
    const orgId = localStorage.getItem("org_id") ? Number(localStorage.getItem("org_id")) : null;

    // 1. Initial state is set to 'false', which corresponds to the collapsed state.
    const [sidebarActive, setSidebarActive] = useState(false);
    const toggleSidebar = () => setSidebarActive(!sidebarActive);

    // Effect to handle initial sidebar state on different screen sizes
    // I am removing the logic that forces it to be expanded on large screens 
    // to strictly adhere to "collapsed by default." The user can expand it with the menu button.
    /*
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) { 
                setSidebarActive(true);
            } else {
                setSidebarActive(false);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);
    */
    // The previous useEffect is commented out to prevent it from overriding the 
    // 'collapsed by default' requirement on large screens.

    return (
        <div className="flex h-screen bg-gray-light font-sans text-text-primary overflow-hidden relative">
            {/* 1. Add mobile classes to Sidebar wrapper */}
            <div className={`
            fixed inset-y-0 left-0 z-50 transform transition-transform duration-300 ease-in-out md:relative md:translate-x-0
            ${sidebarActive ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
        `}>
                <Sidebar isActive={sidebarActive} />
            </div>

            {/* 2. Mobile Overlay: Closes sidebar when user taps the main content area */}
            {sidebarActive && (
                <div
                    className="fixed inset-0 bg-black/40 z-40 md:hidden"
                    onClick={toggleSidebar}
                />
            )}

            {/* 3. Main Content: Ensure it doesn't shrink or overflow weirdly */}
            <div className="flex flex-col flex-1 min-w-0 bg-white border-l border-gray-medium transition-all duration-300">
                <Header onMenuToggle={toggleSidebar} />
                <main className="flex-1 p-4 sm:p-6 overflow-y-auto custom-scrollbar">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default Scaffold;